import UploadResumeFloating from "../UploadResumeFloating";

const HPUploadResumeFloating = () => {
    return (
        <UploadResumeFloating
            signupSource="hp_floating_resume"
            isHomepage={true}
        />
    );
};

export default HPUploadResumeFloating;